module.exports = __webpack_public_path__ + "static/media/hackersposter.a089d7c1.jpg";